<template>
  <div class="grid-x">
    <div :class="_colOneClass">
      <div v-if="showProgress || responsiveShow" class="progress">
        <!-- <div class="status">2/11</div> -->
        <h4
          class="open-wizard"
          style="margin-bottom: 0.2em"
          data-label-type="sub-heading"
        >
          {{ resolveTxt("skin.default.step", "Step") }} {{ selected }}
          {{ resolveTxt("skin.default.of", "of") }} {{ items.length }}
        </h4>
      </div>
      <ol v-if="!suppressSteps" :class="stepsClass">
        <li
          v-for="(item, idx) in items"
          :key="idx"
          :class="{ complete: item.complete, active: item.step == sel }"
        >
          <a
            v-if="!restrictMovement || item.step <= maxStep"
            class="step"
            href="#"
            :data-button="item.title"
            @click.prevent="(event) => _onClick(event, item.step)"
            >{{ item.title }}</a
          >
          <span v-else class="step">{{ item.title }}</span>
          <span class="step-icon"></span>
        </li>
      </ol>
    </div>
    <div :class="_colTwoClass">
      <div class="main-content">
        <a name="main-content"></a>
        <slot></slot>
        <slot name="buttonpad"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
// import jQuery from "jquery";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);
    const addContentClass = inject("addContentClass", null);

    return {
      resolveTxt,
      displayParams,
      addContentClass
    };
  },
  name: "CatTabStepper",
  props: {
    id: {
      type: [String, Number]
    },
    items: {
      type: [Array]
    },
    selected: [Number],
    restrictMovement: {
      type: Boolean,
      default: false
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      sel: this.selected ? this.selected : 1,
      maxStep: this.maxSteps(),
      responsiveShow: true
    };
  },
  watch: {
    selected: function (newsel) {
      this.sel = newsel;
      this.maxStep = this.maxSteps();
    }
  },

  methods: {
    _onClick: function (event, step) {
      // console.log("Clicked on stepper", event, step);
      this.$emit("ui-click", {
        event: event,
        value: step,
        id: this.id ? this.id : null
      });
    },
    maxSteps: function () {
      let maxCompleted = 0;
      this.items.forEach((element) => {
        if (element.complete) {
          maxCompleted = parseInt(element.step);
        }
      });
      if (this.selected < maxCompleted) {
        return maxCompleted;
      }
      return this.selected;
    },
    getColor: function (item) {
      return item.complete ? "primary" : "transparent";
    },
    _getRules: function (item) {
      // console.log("items__", !item.errors.length > 0);
      return [() => item.errors && !item.errors.length > 0];
    },
    save: function () {
      Catalyst.save(this.id);
    }
  },
  computed: {
    numCompleted: function () {
      return this.items.reduce(
        (acc, cur, idx) => acc + (cur.complete ? 1 : 0),
        0
      );
    },
    suppressSteps: function () {
      return this.items.length == 1;
    },
    _colOneClass: function () {
      return (
        "druid" +
        (this.vertical
          ? " vertical small-12 medium-4 medium-push-8 cell"
          : " full")
      );
    },
    _colTwoClass: function () {
      return "" + (this.vertical ? "small-12 medium-8 medium-pull-4 cell" : "");
    },

    stepsClass: function () {
      return {
        visible: this.responsiveShow,
        mtt: this.responsiveShow,
        "druid-steps": true
      };
    }
  },
  created: function () {
    this._default = this.selected ? this.selected : this.items[0].step;
  },

  mounted: function () {
    // if (this.addContentClass) {
    //   this.addContentClass("has-side-content");
    // }
    // jQuery("#" + this.id + "_sticky").sticky({
    //   topSpacing: 100,
    //   bottomSpacing: 100
    // });
  }
  //extends : VMenu,
});
</script>
